<template>
  <section class="keyvis">
    <div class="keyvis_in">
    <h2 class="keyvis_ttl"><span class="keyvis_ttlTxt">Key visual</span></h2>
    <ul class="keyvis_list">
      <li class="keyvis_item">
        <div class="keyvis_itemIn">
          <button class="keyvis_thumb" @click="showModal = true,current = 0">
            <img src="@/assets/img_kv_1_thumb.jpg" alt="Key visual 01" class="keyvis_img">
          </button>
          <p class="keyvis_btnArea">
            <a v-bind:href="imgPath[0]" class="keyvis_btn" download>
              Download
            </a>
          </p>
        </div>
      </li>
      <li class="keyvis_item">
        <div class="keyvis_itemIn">
          <button class="keyvis_thumb" @click="showModal = true,current = 1">
            <img src="@/assets/img_kv_2_thumb.jpg" alt="Key visual 02" class="keyvis_img">
          </button>
          <p class="keyvis_btnArea">
            <a v-bind:href="imgPath[1]" class="keyvis_btn" download>
              Download
            </a>
          </p>
        </div>
      </li>
      <li class="keyvis_item">
        <div class="keyvis_itemIn">
          <button class="keyvis_thumb" @click="showModal=true,current = 2">
            <img src="@/assets/img_kv_3_thumb.jpg" alt="Key visual 03" class="keyvis_img">
          </button>
          <p class="keyvis_btnArea">
            <a v-bind:href="imgPath[2]" class="keyvis_btn" download>
              Download
            </a>
          </p>
        </div>
      </li>
      <li class="keyvis_item">
        <div class="keyvis_itemIn">
          <button class="keyvis_thumb" @click="showModal=true,current = 3">
            <img src="@/assets/img_kv_4_thumb.jpg" alt="Key visual 04" class="keyvis_img">
          </button>
          <p class="keyvis_btnArea">
            <a v-bind:href="imgPath[3]" class="keyvis_btn" download>
            Download
            </a>
          </p>
        </div>
      </li>
       <li class="keyvis_item">
        <div class="keyvis_itemIn">
          <button class="keyvis_thumb" @click="showModal=true,current = 4">
            <img src="@/assets/img_kv_5_thumb.jpg" alt="Key visual 05" class="keyvis_img">
          </button>
          <p class="keyvis_btnArea">
            <a v-bind:href="imgPath[4]" class="keyvis_btn" download>
            Download
            </a>
          </p>
        </div>
      </li>
    </ul>
     </div>
    <transition name="fade">
      <div class="keyvis_modal" v-if="showModal" @close="showModal = false">
        <div class="keyvis_modalIn">
          <div class="keyvis_modalHead">
            <span class="keyvis_modalNum">0{{current+1}}</span>
            <button class="keyvis_modalClose" @click="showModal = false"><img src="@/assets/icon_close_2.svg"
                alt="CLOSE" class="keyvis_modalCloseIcon"></button>
          </div>
          <div class="keyvis_modalImgBox">
            <img v-bind:src="imgThumbPath[current]" class="keyvis_modalThumbImg">
            <img v-bind:src="imgPath[current]" class="keyvis_modalImg">
          </div>
          <div class="keyvis_modalFoot">
            <button @click="current=current<=0?kvMax:current-1" class="keyvis_modalCtrlBtn keyvis_modalCtrlBtn-prev"><img
                src="@/assets/icon_left.svg" alt="PREV" class="keyvis_modalPrevIcon"></button>
            <a v-bind:href="imgPath[current]" class="keyvis_modalBtn" download>
                          <span class="keyvis_modalBtn-pc">Download</span><span class="keyvis_modalBtn-sp">View full size</span>
            </a>
            <button @click="current=current>=kvMax?0:current+1" class="keyvis_modalCtrlBtn keyvis_modalCtrlBtn-next"><img
                src="@/assets/icon_right.svg" alt="NEXT" class="keyvis_modalNextIcon"></button>
          </div>
        </div>
      </div>
    </transition>
   
  </section>
</template>
<script>


export default{
  name: 'app',
  data:function(){
    return{
      showModal: false,
      current: 1,
      kvMax:4,
      imgPath:[
        '/ACAL-0010/img/mazedoll_kv_1.jpg',
        '/ACAL-0010/img/mazedoll_kv_2.jpg',
        '/ACAL-0010/img/mazedoll_kv_3.jpg',
        '/ACAL-0010/img/mazedoll_kv_4.jpg',
        '/ACAL-0010/img/mazedoll_kv_5.jpg',
      ],
      imgThumbPath:[
        require('@/assets/img_kv_1_thumb.jpg'),
        require('@/assets/img_kv_2_thumb.jpg'),
        require('@/assets/img_kv_3_thumb.jpg'),
        require('@/assets/img_kv_4_thumb.jpg'),
        require('@/assets/img_kv_5_thumb.jpg'),
      ],
    }
  },
  methods: {
    changePrev: function () {
 
    },
    changeNext: function (){

    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.keyvis{
  background: #000 url(../assets/bg_kv.svg) center center no-repeat;
  background-size: cover;
  color: #fff;
  padding:72px 0;
  position: relative;
  @include mq(sm){
    padding: 36px 0 24px;
  }
  &_in{
        max-width: 1600px;
    margin:0 auto;
 //   padding:0 12px;
  }
    &_ttl {
    font-family: 'DIN Next LT W01 Bold', 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 18px;
    text-transform: uppercase;
    letter-spacing: .05em;
    padding:0 16px;
    &::after {
      content: '';
      width: 18px;
      height: 18px;
      display: inline-block;
      background: url(../assets/icon_suffix_2.svg) center center no-repeat;
      vertical-align: middle;
    }
  }
  &_list{
    display: flex;
    list-style: none;
    flex-wrap: wrap;
    padding: 0 8px;
    margin-top: 16px;
    justify-content: space-between;
  }
  &_item{
  //  width: 25%;
  //  max-width: 286px;
    padding:8px 8px 36px;
    
        @include mq(lg){
      width: 50%;
    }
    & + &{
  //    padding-left: 2%;
    }
  }
  
  &_itemIn{
text-align: center;
  }
  &_thumb{
    transition:opacity .2s ease;
    &:hover{
  @media screen and (min-width:768px){
      opacity: .8
      
      }
      
    }
  }
  &_img{
    width: 260px;
    @include mq(){
      width: 100%;
    }
    border: solid 1px #eee;
  }
  &_btnArea{
    display: block;
    text-align: center;
    margin-top: 16px;
    @include mq(){
      margin-top: 8px;
    }
  }
  &_btn{
    background-color: #fff;
    color: #000;
    text-decoration: none;
    display: inline-block;
    padding: 12px 40px;
    
    border-radius:2px;
    font-size: 14px;
        font-family: 'DIN Next LT W01 Bold', 'Avenir', Helvetica, Arial, sans-serif;
            text-transform: uppercase;
    letter-spacing: .05em;
       transition:opacity .2s ease;
    &:hover{
 @media screen and (min-width:768px){
      opacity: .8
      
      }
      
    }
@include mq(sm){
  font-size: 12px;
  width: 100%;
  padding: 8px;
}


  }
  &_modal{
    position: fixed;
    z-index: 2;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0,.7);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;


  }
  &_modalIn{
    position: relative;
    
    max-width: 100%;
    padding: 20px;
  }
  &_modalImg{
    width: 800px;
        @include mq(){
      width: 100%;
    }
  }
  &_modalHead{
   display: flex;
   justify-content: space-between;
   align-items: center;
  }
  &_modalNum{
    font-size: 36px;
      font-family:'DIN Next LT W01 Medium';


    @include mq(){
      font-size: 24px;
    }
  }
  &_modalClose{
    display: inline-block;
  }
  &_modalCloseIcon{
    display: block;
    width: 56px;
    height: 56px;
    @include mq(){
      width: 48px;
      height: 48px;
    }
       transition:opacity .2s ease;
    &:hover{
      @media screen and (min-width:768px){
      opacity: .8
      
      }
    }
  }
  &_modalFoot{
    display: flex;
    justify-content: space-between;
    margin-top: 48px;
    @include mq(){
      justify-content: center;
      margin-top: 0;
    }
  }
    &_modalBtn{
    background-color: #fff;
    color: #000;
    text-decoration: none;
    display: inline-block;
    padding: 24px 90px;
    border-radius:4px;
    font-size: 18px;
        font-family: 'DIN Next LT W01 Bold', 'Avenir', Helvetica, Arial, sans-serif;
            text-transform: uppercase;
    letter-spacing: .05em;
   transition:opacity .2s ease;
   text-align: center;
   &-pc{
     display: inline-block;
     @include mq(sm){
       display: none;
     }
   }
   &-sp{
     display: none;
     @include mq(sm){
       display: inline-block;
     }
   }
    &:hover{
      opacity: .8
      
    }
    @include mq(){
      padding:16px;
      min-width: 220px;
      font-size: 16px;
        border-radius: 0;
    }

  }
      &_modalCtrlBtn{
    background-color: #fff;
    color: #000;
    text-decoration: none;
    display: inline-block;
    padding: 8px;
    border-radius:4px;
    font-size: 18px;
        font-family: 'DIN Next LT W01 Bold', 'Avenir', Helvetica, Arial, sans-serif;
            text-transform: uppercase;
    letter-spacing: .05em;
       transition:opacity .2s ease;
    &:hover{
 @media screen and (min-width:768px){
      opacity: .8
      
      }
      
    }
@include mq(){
  padding:8px 16px;

}


  }
  &_modalCtrlBtn-prev{
    @include mq(){
      border-radius: 4px 0 0 4px;
      margin-right: 1px;
    }
  }
    &_modalCtrlBtn-next{
    @include mq(){
      border-radius: 0 4px 4px 0;
      margin-left: 1px;
    }
  }
  &_modalImgBox{
    width:800px;
    height: 450px;
    position: relative;

    @include mq(){
      width: 100%;
      height: 200px;
      padding: 0 10px;
    }
  }
  &_modalImg,
  &_modalThumbImg{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    
  }
  &_modalPrevIcon,
    &_modalNextIcon{
   display: block;
    width: 56px;
    height: 56px;
    @include mq(){
      width: 24px;
      height: 24px;
    }
  }
}

</style>